import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { LayoutModule } from './layout/app.layout.module';
import { LoginComponent } from './login/login.component';
import { AuthService } from './services/auth.service';
import { tokenInterceptor } from './services/token.interceptor';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox'
import { InputTextModule } from 'primeng/inputtext'
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { CheckoutComponent } from './paynow/checkout/checkout.component';
import { PartnerImageComponent } from './paynow/partner-image/partner-image.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PanelModule } from 'primeng/panel';
import { DividerModule } from 'primeng/divider';
import { spinnerInterceptor } from './services/spinner-interceptor';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from './shared/shared.module';
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { ErrorComponent } from './paynow/error/error.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ExpiredComponent } from './expired/expired.component';

import { ReceiptComponent } from './paynow/receipt/receipt.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { PaymentErrorComponent } from './paynow/payment-error/payment-error.component';
import { SessionExpiredComponent } from './sessionExpired/session-expired.component';
import { DialogModule } from 'primeng/dialog';
import { InputMaskModule } from 'primeng/inputmask';
import { ToastModule } from 'primeng/toast';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        CheckoutComponent,
        PartnerImageComponent,
        ErrorComponent,
        ReceiptComponent,
        PartnerImageComponent,
        ExpiredComponent,
        NotFoundComponent,
        PaymentErrorComponent,
        SessionExpiredComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        LayoutModule,
        MessagesModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PanelModule,
        DividerModule,
        DropdownModule,
        SharedModule,
        RadioButtonModule,
        DialogModule,
        InputMaskModule,
        ToastModule,
        NgIdleKeepaliveModule.forRoot()],
    providers: [
        provideHttpClient(
            withInterceptors([
                //spinnerInterceptor, 
                tokenInterceptor]) // Add TokenInterceptor here
          ),
          AuthService, // Provide AuthService
          MessageService
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
